import { useFormDataContext } from "@totalenergiescode/mobility-business-rev-form-data/components";
import type { FormFieldContract } from "@totalenergiescode/mobility-business-rev-form-data/lib";

interface FormFieldDebugOverlayProps {
  field: FormFieldContract;
}

const FormFieldDebugOverlay = ({ field }: FormFieldDebugOverlayProps) => {
  const { debug } = useFormDataContext();

  if (!debug) {
    return null;
  }

  return (
    <div className={"field-debug-overlay"}>
      <span>{field.id()}</span>
    </div>
  );
};

export default FormFieldDebugOverlay;
